import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";

import { HttpHeaders, HttpErrorResponse } from "@angular/common/http";
@Injectable()
export class RegistrationService {
  constructor(private http: HttpClient) {}
  getAproveduser(
    slotId,
    page,
    search,
    institution,
    course,
    degree,
    roll_no
  ): Observable<any> {
    if (!search) {
      search = "";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/approved-users?slotId=` +
          slotId +
          "&page=" +
          page +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&roll_no=" +
          roll_no
      )
      .pipe(map((user) => user));
  }

  getEmployee(slotId, page, search): Observable<any> {
    if (!search) {
      search = "";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/employee?slotId=` +
          slotId +
          "&page=" +
          page +
          "&search=" +
          search
      )
      .pipe(map((user) => user));
  }

  getAprovedusercount(
    slotId,
    page,
    search,
    institution,
    course,
    degree,
    roll_no
  ): Observable<any> {
    if (!search) {
      search = "";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/approved-users-count?slotId=` +
          slotId +
          "&page=" +
          page +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&roll_no=" +
          roll_no
      )
      .pipe(map((user) => user));
  }

  addqrcount(id, accompany): Observable<any> {
    return this.http
      .post<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/extra-qr`,
        { bookingId: id, acompany: accompany }
      )
      .pipe(map((user) => user));
  }

  changeimagestatus(id, status): Observable<any> {
    return this.http
      .post<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/update-photo-status/`+id,
        { status: status }
      )
      .pipe(map((user) => user));
  }

  updateAlmashineStatus(id, payload): Observable<any> {
    return this.http
      .put<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/update-almashine-status/${id}`,
        payload
      )
      .pipe(map((user) => user));
  }

  updatedate(id, date): Observable<any> {
    return this.http
      .put<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/update-course-completion-date/${id}`,
        { course_completion_date: date }
      )
      .pipe(map((user) => user));
  }

  getUserphotos(
    page,
    search,
    institution,
    startdate,
    enddate: any,
    event
  ): Observable<any> {
    if (!search) {
      search = "";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/users-photos?page=` +
          page +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&start_date=" +
          startdate +
          "&end_date=" +
          enddate +
          "&eventId=" +
          event
      )
      .pipe(map((user) => user));
  }

  getPostalphotos(
    page,
    search,
    institution,
    startdate,
    enddate: any,
    event
  ): Observable<any> {
    if (!search) {
      search = "";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/postals-users-photos?page=` +
          page +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&start_date=" +
          startdate +
          "&end_date=" +
          enddate +
          "&eventId=" +
          event
      )
      .pipe(map((user) => user));
  }

  getUsercount(slotId): Observable<any> {
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/approved-users-count?slotId=` +
          slotId
      )
      .pipe(map((user) => user));
  }

  getInstitute(): Observable<any> {
    return this.http
      .get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/institute`)
      .pipe(map((user) => user));
  }

  getFeedback(page, event): Observable<any> {
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/feedback-list?page=` +
          page +
          "&eventId=" +
          event
      )
      .pipe(map((user) => user));
  }

  getUserDeatils(page, info, search): Observable<any> {
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/view-info?page=` +
          page +
          "&info=" +
          info +
          "&search=" +
          search
      )
      .pipe(map((user) => user));
  }

  getnotattendedstudent(page, info, slotId,search): Observable<any> {
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/not-booked-students?page=` +
          page +
          "&info=" +
          info +
          "&eventId=" +
          slotId +
          "&search=" +
          search
      )
      .pipe(map((user) => user));
  }

  getCourse(id): Observable<any> {
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/course/institute/` +
          id
      )
      .pipe(map((user) => user));
  }

  getDegree(): Observable<any> {
    return this.http
      .get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/degree`)
      .pipe(map((user) => user));
  }

  getEvents(page): Observable<any> {
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/events?page=` +
          page
      )
      .pipe(map((user) => user));
  }

  downloaduser(
    slotId,
    search,
    institution,
    course,
    degree,
    roll_no
  ): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/users-export-excel?slotId=` +
          slotId +
          "&page=" +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&roll_no=" +
          roll_no,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  downloadconvocationreport(slotId, event): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/reports/totalBookedStudents?slotId=` +
          slotId +
          "&eventId=" +
          event,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  downloadinstitutereport(slotId, event): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/reports/inst-wise?slotId=` +
          slotId +
          "&eventId=" +
          event,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  downloadpostalreport(event): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/reports/postal?eventId=` +
          event,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  downloaddegreereport(slotId, event): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/reports/degree-wise?slotId=` +
          slotId +
          "&eventId=" +
          event,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  downloademployee(slotId, search): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/employee/download?slotId=` +
          slotId,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  downloaImage(institution, startdate, enddate): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/users-photos-download?institution=` +
          institution +
          "&start_date=" +
          startdate +
          "&end_date=" +
          enddate,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  downloadPostalImage(institution, startdate, enddate): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/postals-photos-download?institution=` +
          institution +
          "&start_date=" +
          startdate +
          "&end_date=" +
          enddate,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  //On Postal
  getPostaluser(
    page,
    search,
    institution,
    course,
    degree,
    roll_no,
    status,
    event
  ): Observable<any> {
    if (!search) {
      search = "";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/postal-users?page=` +
          page +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&roll_no=" +
          roll_no +
          "&status=" +
          "" +
          "&eventId=" +
          event
      )
      .pipe(map((user) => user));
  }

  getPostalcount(institution, course, degree): Observable<any> {
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/postal-users/counts?institution=` +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree
      )
      .pipe(map((user) => user));
  }

  downloadPostaluser(
    search,
    institution,
    course,
    degree,
    roll_no
  ): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/postal-users/export-excel?search=` +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&roll_no=" +
          roll_no,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }
  downloadTransactionDetails(
    search,
    institution,
    course,
    status,
    eventid,payment
  ): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/transactions/download?search=` +
          search +
          "&institute=" +
          institution +
          "&course=" +
          course +
          "&status=" +
          status +
          "&eventId=" +
          eventid+
          "&payment="+payment,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  downloadrefundDetails(search, institution, course): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/refunds/download?search=` +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  getTransaction(
    page,
    search,
    institution,
    course,
    status,
    event,paymentType:string
  ): Observable<any> {
    if (!search) {
      search = "";
    }
    if (!status) {
      status = "";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/transactions?page=` +
          page +
          "&search=" +
          search +
          "&institute=" +
          institution +
          "&course=" +
          course +
          "&status=" +
          status +
          "&eventId=" +
          event
          +"&payment=" +
          paymentType
      )
      .pipe(map((user) => user));
  }

  getTransactionamount(eventid): Observable<any> {
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/transactions/totalamount?eventId=` +
          eventid
      )
      .pipe(map((user) => user));
  }

  downloadTransaction(search, institution, course, status): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/users-export-excel?search=` +
          search +
          "&institute=" +
          institution +
          "&course=" +
          course,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  getRefund(page, search, institution, course, status, event): Observable<any> {
    if (!search) {
      search = "";
    }
    if (!status) {
      status = "";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/refunds?page=` +
          page +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&status=" +
          status +
          "&eventId=" +
          event
      )
      .pipe(map((user) => user));
  }

  updateRefund(id: any, status: any) {
    var formData = {
      status: status,
    };
    return this.http
      .post<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/refunds/update/` +
          id,
        formData
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  deleteRefund(id: string) {
    return this.http
      .delete<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/refunds/delete/` +
          id
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  getAlmashineUser(
    page,
    search,
    institution,
    course,
    degree,
    status,
    eventId,
    roll_no,fromdate,todate
  ): Observable<any> {
    if (!search) {
      search = "";
    }
    if(fromdate&&todate){
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/almashine-entries-list?page=` +
          page +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&status=" +
          status +
          "&eventId=" +
          eventId +
          "&roll_no=" +
          roll_no +
          "&from_date=" +
          fromdate +
          "&to_date=" +
          todate
      )
      .pipe(map((user) => user));
    }else{
      return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/almashine-entries-list?page=` +
          page +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&status=" +
          status +
          "&eventId=" +
          eventId +
          "&roll_no=" +
          roll_no
      )
      .pipe(map((user) => user));
    }
  }

  getAlmashineUserCount(
    page,
    search,
    institution,
    course,
    degree,
    status,
    eventId,
    roll_no
  ): Observable<any> {
    if (!search) {
      search = "";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/almashine-entries-count?page=` +
          page +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&status=" +
          status +
          "&eventId=" +
          eventId +
          "&roll_no=" +
          roll_no
      )
      .pipe(map((user) => user));
  }

  downloadAlmashineUser(
    search,
    institution,
    course,
    degree,
    status,
    eventId,
    roll_no,fromdate,todate
  ): Observable<any> {
    if(fromdate&&todate){
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/almashine-export-excel?search=` +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&status=" +
          status +
          "&eventId=" +
          eventId +
          "&roll_no=" +
          roll_no+
          "&from_date=" +
          fromdate +
          "&to_date=" +
          todate,

        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
    }else{
      const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/almashine-export-excel?search=` +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&status=" +
          status +
          "&eventId=" +
          eventId +
          "&roll_no=" +
          roll_no,

        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
    }
  }

  uploadAlmashineUser(file: File, event: any) {
    const formData: FormData = new FormData();
    if (file) {
      formData.append("file", file, file.name);
      formData.append("eventId", event);
      return this.http
        .post<any>(
          ` ${environment.apiUrl}${environment.apiPrefix}/admin/almashine-import-excel`,
          formData
        )
        .pipe(
          map((user) => {
            return user;
          })
        );
    }
  }

  saveContentForm(
    header: any,
    institutes: number[],
    title: any,
    second_title: any,
    description: any,
    description_link: any,
    terms_conds_link: any,
    photo_title: any,
    photo: File
  ) {
    const formData = new FormData();
    formData.append("header", header);
    formData.append("institutes", JSON.stringify(institutes));
    formData.append("title", title);
    formData.append("second_title", second_title);
    formData.append("description", description);
    formData.append("description_link", description_link);
    formData.append("terms_conds_link", terms_conds_link);
    formData.append("photo_title", photo_title);

    if (photo) {
      formData.append("photo", photo); // ✅ send file as binary
    }
    return this.http
      .post<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/institute-almashine/create`,
        formData
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  getAlmashineForm(page, search): Observable<any> {
    if (!search) {
      search = "";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/institute-almashine?page=` +
          page +
          "&search=" +
          search
      )
      .pipe(map((user) => user));
  }

  updateContentForm(
    id: any,
    header: any,
    institutes: number[],
    title: any,
    second_title: any,
    description: any,
    description_link: any,
    terms_conds_link: any,
    photo_title: any,
    photo: File
  ) {
    const formData = new FormData();
    formData.append("header", header);
    formData.append("institutes", JSON.stringify(institutes));
    formData.append("title", title);
    formData.append("second_title", second_title);
    formData.append("description", description);
    formData.append("description_link", description_link);
    formData.append("terms_conds_link", terms_conds_link);
    formData.append("photo_title", photo_title);

    if (photo) {
      formData.append("photo", photo); // ✅ send file as binary
    }
    return this.http
      .put<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/institute-almashine/update/` +
          id,
        formData
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  deleteAlmashineForm(id: string) {
    return this.http
      .delete<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/institute-almashine/delete/` +
          id
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  getImageRecognitionList(
    page,
    search,
    institution,
    course,
    degree,
    status,
    eventId,
    roll_no,
    receivedConvocationImage
  ): Observable<any> {
    if (!search) {
      search = "";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/almashine-listReceivedConvocationImages?page=` +
          page +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&status=" +
          status +
          "&eventId=" +
          eventId +
          "&roll_no=" +
          roll_no +
          "&receivedConvocationImage=" +
          receivedConvocationImage
      )
      .pipe(map((user) => user));
  }

  geteventdata( slotId): Observable<any> {
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/events/get-event/`+slotId
      )
      .pipe(map((user) => user));
  }

  updatemessage(id, data): Observable<any> {
    return this.http
      .put<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/events/update?id=`+id,
     data
      )
      .pipe(map((user) => user));
  }

  updateaccompany(id, data, institutes?): Observable<any> {
    let formdata={
      eventId:id,
      accompanies:data,
      institutes:institutes
    }
    return this.http
      .post<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/events/set-accompanies`,
        formdata
      )
      .pipe(map((user) => user));
  }

  getAltUserList(
    page,
    search,
    institution,
    course,
    degree,
    reporting_status
  ): Observable<any> {
    if (!search) {
      search = "";
    }
    if (!institution) {
      institution = "ALL";
    }
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/alt-user-list?page=` +
          page +
          "&search=" +
          search +
          "&institution=" +
          institution +
          "&course=" +
          course +
          "&degree=" +
          degree +
          "&reporting_status=" +
          reporting_status
      )
      .pipe(map((user) => user));
  }

  uploadAltUserExcel(file: File) {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    return this.http
      .post<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/alt-user-excel-upload`,
        formData
      )
      .pipe(map((user) => user));
  }

  editAltUser(id, payload): Observable<any> {
    return this.http
      .put<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/alt-user-edit/${id}`,
        payload
      )
      .pipe(map((user) => user));
  }

  downloadAltUserSampleExcel(): Observable<any> {
    return this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/alt-user-excel-download`,
        { responseType: "blob" as "json" }
      )
      .pipe(map((user) => user));
  }

  deleteAltUser(id: string): Observable<any> {
    return this.http
      .delete<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/alt-user-delete/${id}`
      )
      .pipe(map((user) => user));
  }

  downloadNotAttendeduser(
    slotId,
   search:string
  ): Observable<any> {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/not-booked-students-download?eventId=` +
          slotId +
          "&search=" +
          search +
          "&info=" +
          'NOTATTENDED',
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }
}
